import { createField } from '@/components/forms/field.schema';
import {
  Calendar,
  Clock,
  Database,
  Hash,
  HardDrive,
  Key,
  Search,
  User,
} from 'lucide-react';
import { z } from 'zod';

/** Columns and filter tokens of the cache entries table. */
export const cacheEntryFields = {
  resource: createField(z.string(), {
    fieldType: 'text',
    label: 'Resource',
    readOnly: true,
    icon: Database,
  }),
  query: createField(z.string(), {
    fieldType: 'text',
    label: 'Query',
    readOnly: true,
    icon: Search,
  }),
  principal: createField(z.string(), {
    fieldType: 'text',
    label: 'Principal',
    readOnly: true,
    icon: User,
  }),
  size: createField(z.number(), {
    fieldType: 'text',
    label: 'Size',
    readOnly: true,
    icon: HardDrive,
  }),
  stored_size: createField(z.number(), {
    fieldType: 'text',
    label: 'Stored',
    readOnly: true,
    icon: HardDrive,
  }),
  status: createField(z.number(), {
    fieldType: 'text',
    label: 'Status',
    readOnly: true,
    icon: Hash,
  }),
  last_hit: createField(z.string(), {
    fieldType: 'date',
    label: 'Last hit',
    readOnly: true,
    icon: Clock,
  }),
  created: createField(z.string(), {
    fieldType: 'date',
    label: 'Created',
    readOnly: true,
    icon: Calendar,
  }),
  key: createField(z.string(), {
    fieldType: 'text',
    label: 'ETag',
    readOnly: true,
    icon: Key,
  }),
};
